import BookmarkStorage from "../../bookmark/js/BookmarkStorage";
import BookmarkButtons from "../../bookmark/js/BookmarksButtons";
import ArticleStorage from "../../article/js/ArticleStorage";
import Notification from "../../notification/js/Notification";
import SimpleFormValidation from "../../forms/js/SimleFormVadliation";
import QuizPageChecker from "../../QuizScreenStart/js/QuizPageChecker";
import interactionTracking from "../../utils/interactionTracking";
import layoutTracking from "../../utils/layoutTracking";

(function () {
    ("use strict");

    // Global variables
    var squiz = {
        fn: {},
        vars: {
            bookmarkNotification: true, // should we display a notification on bookmarking a page?
        },
        breakpoints: {
            sm: window.matchMedia("(min-width: 0px) and (max-width: 768px)"),
            md: window.matchMedia("(min-width: 769px) and (max-width: 1024px)"),
            lg: window.matchMedia(
                "(min-width: 1025px) and (max-width: 1440px)",
            ),
            xl: window.matchMedia(
                "(min-width: 1441px) and (max-width: 1920px)",
            ),
        },
        /*let mobile = window.matchMedia("(min-width: 0px) and (max-width: 768px)");
        let tablet = window.matchMedia("(min-width: 769px) and (max-width: 1024px)");
        let desktop = window.matchMedia("(min-width: 1025px)");*/
        /*
        sm: 768,
    md: 1024,
    lg: 1440,
    xl: 1920,
    */
    };

    // Functions
    //squiz.fn.sampleFunction = function () {};

    // Initialise the bookmark buttons feature (globally)
    squiz.fn.BookmarkStorage = new BookmarkStorage();

    // default bookmark buttons
    squiz.fn.BookmarkButtons = new BookmarkButtons();

    // default article storage
    squiz.fn.ArticleStorage = new ArticleStorage();

    // notification class
    squiz.fn.Notification = Notification;

    // global form validation
    squiz.fn.SimpleFormValidation = SimpleFormValidation;

    // quiz page checker
    squiz.fn.QuizPageChecker = new QuizPageChecker();

    // Make squiz variable available to the console for debugging
    window.squiz = squiz;
})();

/**
 * Click tracking
 */

function customTracking() {
    interactionTracking();
    layoutTracking();
}

customTracking();
